/**
 * Case transformation utilities
 * Converts between naming conventions (PascalCase/snake_case → camelCase)
 */

/**
 * Convert PascalCase/snake_case object keys to camelCase (shallow)
 * Handles both PascalCase → camelCase and snake_case → camelCase
 *
 * @example
 * toCamelCase({ NetworkId: 1, billing_status: 'active' })
 * // → { networkId: 1, billingStatus: 'active' }
 */
export function toCamelCase(obj: any): any {
  if (!obj || typeof obj !== 'object') return obj;

  // Handle arrays: recurse into each element
  if (Array.isArray(obj)) {
    return obj.map((item) => toCamelCase(item));
  }

  const result: any = {};
  for (const key in obj) {
    let camelKey = key.charAt(0).toLowerCase() + key.slice(1);
    camelKey = camelKey.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    result[camelKey] = toCamelCase(obj[key]);
  }
  return result;
}
